const range = (start, end) => {
  if (end < start) return [];
  return Array.from({ length: end - start + 1 }, (_, index) => start + index);
};

export const buildPaginationItems = (currentPage, totalPages, siblingCount = 1) => {
  if (totalPages <= 0) return [];

  const totalPageNumbersToShow = siblingCount * 2 + 5;
  if (totalPages <= totalPageNumbersToShow) {
    return range(1, totalPages);
  }

  const leftSiblingIndex = Math.max(currentPage - siblingCount, 1);
  const rightSiblingIndex = Math.min(currentPage + siblingCount, totalPages);
  const shouldShowLeftDots = leftSiblingIndex > 2;
  const shouldShowRightDots = rightSiblingIndex < totalPages - 1;

  if (!shouldShowLeftDots && shouldShowRightDots) {
    const leftRange = range(1, 3 + siblingCount * 2);
    return [...leftRange, "dots-right", totalPages];
  }

  if (shouldShowLeftDots && !shouldShowRightDots) {
    const rightRange = range(totalPages - (2 + siblingCount * 2), totalPages);
    return [1, "dots-left", ...rightRange];
  }

  return [
    1,
    "dots-left",
    ...range(leftSiblingIndex, rightSiblingIndex),
    "dots-right",
    totalPages,
  ];
};
